var _this = this;

import { getUserWorkouts } from '../generated';
export var getUserWorkoutsWithMuscleGroupScore = function getUserWorkoutsWithMuscleGroupScore() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return getUserWorkouts.apply(_this, args);
};